import { Maximize2, Minimize2 } from "@aircall/react-icons";

const collapse = {
  icon: Minimize2,
  tooltip: "reduce",
};

const expand = {
  icon: Maximize2,
  tooltip: "expand",
};

export const getProps = (isExpanded: boolean) =>
  isExpanded ? collapse : expand;
